<template>
  <div id="app">
    <header>
      <img class="logo" src="assets/logo.svg" alt="liuteria classica jesi logo">
      <div class="cover">          
        <parallax :sectionHeight="45" :breakpoint="'(min-width:0px)'" :speedFactor="0.3">
          <img src="assets/violini.jpg" alt="foto violini">
        </parallax>
      </div>
    </header>
    <main>
      <h1 class="main-title">Liuteria Classica Jesi</h1>
      <h2>Promuove</h2>
      <Gewa :gewa="gewaData" />
    </main>
    
    <footer>
      <h2>Contatti</h2>
      <p><strong>Liuteria Classica di Giuseppe Quagliano</strong></p>
      <p>tel: 0731 200778<br>email: <a href="mailto: info@liuteriaclassicajesi.it">info@liuteriaclassicajesi.it</a></p>
      <p>Via Mura Occidentali, 20<br>60035 Jesi AN</p>
    </footer>

  </div>
</template>

<script>
import Parallax from 'vue-parallaxy'

import gewaData from './data/gewa.json'
import Gewa from './components/Gewa.vue'

export default {
  name: 'app',
  components: {
    Gewa,
    Parallax
  },
  data () {
    return {
      gewaData
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Lato:300,400,700');
:root {
  font-size:20px;
}
body {
  margin: 0;
  font-size: 16px;
}
* {
  box-sizing: border-box;
}
#app {
  font-family: 'Lato', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
}

h1, h2 {
  font-weight: normal;
}

h2 {
  font-size: 1.5em;
  font-weight: 300;
  text-transform: uppercase;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #000;
}
strong {
  font-weight: 700;
}
@media screen and (min-width: 768px) {
  #app .Masthead {
    min-height: 0;
  }
}

</style>

<style scoped>
  header .logo {
    margin: 2rem 0;
  }
  .cover {
    margin-bottom: 3rem;
  }
  .main-title {
    display: none;
  }
  footer {
    margin: 2rem 0;
  }
  footer p {
    margin: .4rem 0;
  }
</style>